import { mutator } from 'satcheljs';
import { activityFeedItemsSeen } from '../actions/activityFeedItemsSeen';
import { getActivityFeedStore } from '../store/store';

mutator(activityFeedItemsSeen, ({ itemIds }) => {
    const store = getActivityFeedStore();
    itemIds.forEach(itemId => {
        store.items.get(itemId).isSeen = true;
    });
});
